import styled from "styled-components";

export const StyledCountrySelector = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  max-width: 238px;
  font-family: "Inter", sans-serif;
  gap: 8px;
`;

export const StyledLabel = styled.label`
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.netural800};
`;

export const StyledCountrySelectorBody = styled.div<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${({ theme }) => theme.colors.white};
  border: 2px solid ${({ theme }) => theme.colors.netural300};
  border-radius: 8px;
  padding: 12px 16px;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
`;

export const StyledCountrySelectorItem = styled.div<{ isPlaceholder?: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 15px;
  font-weight: 500;
  width: 100%;
  justify-content: space-between;
  color: ${({ isPlaceholder, theme }) =>
    isPlaceholder ? theme.colors.netural400 : "inherit"};
`;

export const StyledArrow = styled.img<{ isOpen: boolean }>`
  transition: transform 0.2s ease;
  transform: rotate(${({ isOpen }) => (isOpen ? 180 : 0)}deg);
`;

export const StyledCountrySelectorDropdown = styled.div<{ isOpen: boolean }>`
  position: absolute;
  top: calc(100% + 1em);
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  max-height: ${({ isOpen }) => (isOpen ? "300px" : "0")};
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  transform: translateY(${({ isOpen }) => (isOpen ? "0" : "-10px")});
  pointer-events: ${({ isOpen }) => (isOpen ? "auto" : "none")};
  transition: max-height 0.3s ease, opacity 0.25s ease, transform 0.25s ease;
  background: ${({ theme }) => theme.colors.white};
  border: 2px solid ${({ theme }) => theme.colors.netural300};
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  z-index: 10;
  overflow-y: auto;
`;

export const StyledCountrySelectorDropdownItem = styled.div<{
  selected?: boolean;
}>`
  padding: 12px 16px;
  cursor: pointer;
  align-items: center;
  background: ${({ selected, theme }) =>
    selected ? theme.colors.primary50 : "transparent"};
  &:hover {
    background: ${({ selected, theme }) =>
      selected ? theme.colors.primary50 : theme.colors.netural100};
    opacity: 0.8
  }
`;
